import * as XLSX from 'xlsx'
import FileSaver from 'file-saver'
import XLSXS from 'xlsx-style'

/**
 * 根据DOM进行导出
 * @param {Element} dom 
 * @param {String} fileName 
 */
export function exportExcelByData(data, fileName, mergesData) {



  // 使用 aoa_to_sheet 创建工作表
  const ws = XLSX.utils.aoa_to_sheet(data);
  

  // 设置单元格格式
  // ws['A1'].s = { // Header 1
  //   font: { bold: true, color: { rgb: "FF0000" } }, // 字体加粗，颜色为红色
  //   alignment: { horizontal: "center", vertical: "center" }, // 居中对齐
  // };

  // ws['B1'].s = { // Header 2
  //   font: { italic: true }, // 字体斜体
  //   fill: { fgColor: { rgb: "FFFF00" } }, // 背景色为黄色
  // };
  // ws['!merges'] = [
  //   { s: { r: 2, c: 1 }, e: { r: 2, c: 2 } }, // 合并第二行的第二列和第三列
  // ];
  ws['!merges'] = mergesData;
  // 为单元格添加边框
  ws['A2'].s = {
    border: {
      top: { style: "thin", color: { rgb: "000000" } },
      bottom: { style: "thin", color: { rgb: "000000" } },
      left: { style: "thin", color: { rgb: "000000" } },
      right: { style: "thin", color: { rgb: "000000" } },
    }
  };
  setExcelStyle(ws)
  // 创建工作簿
  const wb = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');

  let wbout = XLSXS.write(wb, {
    bookType: 'xlsx',
    bookSST: false,
    type: 'binary'
  })
  try {
    FileSaver.saveAs(new Blob([s2ab(wbout)], { type: "application/octet-stream" }), fileName);
  } catch (e) {
    console.error(e, wbout, '----->>>')
  }

}
// 设置导出Excel样式（统一样式）
function setExcelStyle(data) {
  data["!cols"] = []
  const excludes = ['!cols', '!fullref', '!merges', '!ref', '!rows']
  for (let key in data) {
    if (data.hasOwnProperty(key)) {
      if (!excludes.includes(key)) {
        let leftOrCenter = (key === 'A1' || key === 'A2') ? "left" : 'center'
        data[key].s = {
          alignment: {
            horizontal: leftOrCenter, //水平居中对齐
            vertical: leftOrCenter, // 垂直居中
            wrapText: false,
          },
          border: {
            top: {
              style: 'thin',
              color: { rgb: '000000' }
            },
            bottom: {
              style: 'thin',
              color: { rgb: '000000' }
            },
            left: {
              style: 'thin',
              color: { rgb: '000000' }
            },
            right: {
              style: 'thin',
              color: { rgb: '000000' }
            }
          },
          font: {
            sz: 11,
          },
          bold: true,
          numFmt: 0,
        }
        // 单元格宽度
        // data["!cols"].push({ wpx });
        // 根据不同行添加单元格背景颜色
        let color = 'ffffff'
        data[key].s.fill = { fgColor: { rgb: color, patternType: 'solid' } }
        data[key].t = 's';//设置单元格格式为字符串
      }
    }
  }
}
function s2ab(s) {
  var buf = new ArrayBuffer(s.length)
  var view = new Uint8Array(buf)
  for (var i = 0; i !== s.length; ++i) view[i] = s.charCodeAt(i) & 0xff
  return buf
}